/* fy-sticky-cta — barra fixa de CTA.
   Aparece só depois que o alvo (o buy box do hero) sai de vista e
   some novamente quando ele volta. O botão apenas rola até o alvo:
   nenhum formulário de produto é duplicado aqui. */
(() => {
  if (customElements.get('fy-sticky-cta')) return;

  class FyStickyCta extends HTMLElement {
    connectedCallback() {
      this.link = this.querySelector('[data-fy-sticky-link]');
      const targetId = this.dataset.target;
      this.target = targetId ? document.getElementById(targetId) : null;

      if (this.link) {
        this.link.addEventListener('click', (event) => {
          if (!this.target) return;
          event.preventDefault();
          this.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      }

      this.publishHeight();
      this.onResize = this.publishHeight.bind(this);
      window.addEventListener('resize', this.onResize);

      /* acompanha a troca de pacote feita no seletor de planos */
      this.titleEl = this.querySelector('[data-fy-sticky-title]');
      this.priceEl = this.querySelector('[data-fy-sticky-price]');
      this.compareEl = this.querySelector('[data-fy-sticky-compare]');
      this.priceSource = this.dataset.priceSource || 'subscription';
      this.onVariantChange = this.updatePrice.bind(this);
      document.addEventListener('fy:variant-change', this.onVariantChange);

      if (!this.target) {
        this.setVisible(true);
        return;
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            /* Só depois que o alvo (buy box) já passou para CIMA da viewport.
               Antes dele (topo da página, alvo ainda abaixo da dobra) a barra
               fica escondida — senão ela apareceria logo na entrada no mobile,
               antes de a pessoa sequer ver o preço. */
            const passed = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
            this.setVisible(passed);
          });
        },
        { threshold: 0 }
      );
      this.observer.observe(this.target);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      window.removeEventListener('resize', this.onResize);
      document.removeEventListener('fy:variant-change', this.onVariantChange);
      document.body.classList.remove('fy-has-sticky-cta');
    }

    updatePrice(event) {
      if (!this.priceEl || !this.titleEl || this.titleEl.hasAttribute('data-price-hidden')) return;
      const detail = event.detail || {};
      const price =
        this.priceSource === 'subscription'
          ? detail.subscriptionPrice || detail.price
          : detail.price;
      if (!price) return;

      const suffix = this.titleEl.dataset.priceSuffix || '';
      this.priceEl.textContent = `${price}${suffix}`;

      if (!this.compareEl) return;
      /* âncora do riscado: preço cheio sem bundle (compare_at_price), a mesma
         do widget de assinatura; sem ele, o preço da variante */
      const compare = detail.comparePrice || detail.price;
      const showCompare =
        this.titleEl.hasAttribute('data-show-compare') &&
        compare &&
        compare !== price;
      this.compareEl.textContent = showCompare ? compare : '';
      this.compareEl.hidden = !showCompare;
    }

    setVisible(visible) {
      this.classList.toggle('is-visible', visible);
      /* marca o body para que widgets flutuantes de apps (rewards, chat…)
         possam ser empurrados acima da barra em vez de sobrepô-la */
      document.body.classList.toggle('fy-has-sticky-cta', visible);
      if (visible) this.publishHeight();
    }

    publishHeight() {
      const height = Math.round(this.getBoundingClientRect().height);
      if (height) {
        document.documentElement.style.setProperty('--fy-sticky-cta-height', `${height}px`);
      }
    }
  }

  customElements.define('fy-sticky-cta', FyStickyCta);
})();
